<template>
  <div class="container">
    <myNav></myNav>
    <div class="pro-con">
      <el-row>
        <!-- <el-col :span="4">
            <div class="grid-content bg-purple">qqq</div>
          </el-col> -->
        <el-col :span="24">
          <div class="grid-content bg-purple-light">
            <el-row>
              <el-col :span="8" v-for="item in proData" :key="item.id">
                <div class="sup-item" @click="moreInfor(item.id)">
                  <div class="sup-img" v-if="item.main_img_url"><img :src="item.main_img_url" alt="" /></div>
                  <div class="sup-img" v-else="item.main_img_url == null"><img src="@/assets/no.jpg" alt="" /></div>
                  <div class="sup-info">
                    <div class="sup-title">{{ item.name }}</div>
                    <div class="sup-text"><p v-html="item.intro"></p></div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import myNav from './nav/myNav'
import { proModuleApi } from '@/api/home'
export default {
  components: {
    myNav
  },
  data() {
    return {
      id: '',
      proData: []
    }
  },
  created() {
    this.id = this.$route.query.id
    console.log(this.id)
    this.getProInfo()
  },
  methods: {
    clickReload() {
      // 点击之后强制刷新
      this.reload()
    },
    getProInfo() {
      proModuleApi
        .productClassify(this.id, 0)
        .then(res => {
          console.log(res)
          this.proData = res.data
        })
        .catch()
    },
    moreInfor(id) {
      this.$router.push({
        path: '/infor',
        query: {
          id: id
        }
      })
    }
  }
}
</script>
<style scoped>
.pro-con {
  width: 1200px;
  margin: 0 auto;
}

.el-col {
  padding: 10px 20px;
}
.sup-item {
  width: 100%;
  height: 300px;
  /* text-align: center; */
  box-shadow: 0 0 8px 0 #cfcfcf;
  border-radius: 5px;
  padding: 5px 10px;
}

.sup-img {
  width: 100%;
  height: 200px;
  text-align: center;
}

.sup-img img {
  max-width: 100%;
  max-height: 180px;
}

.sup-title {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  /* display: -webkit-box; */
  text-align: center;
  font-weight: bold;
  color: #107a53;
}
.sup-text {
  margin-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/components/detail.vue